import React from "react";
import pages from "../data/pages";
import { Switch, BrowserRouter, Route, Link } from "react-router-dom";

const Navbar = ({ changePage }) => (
  <header id="header">
    <nav>
      {pages.map((pageName, index) => (
        <a className="navElement" key={index} href={pageName.toLowerCase()}>
          {pageName}
        </a>
      ))}
    </nav>
  </header>
);

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/navbar.js